import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "redux/axiosInterceptor";

const API_URL = process.env.REACT_APP_BASE_URL;

const initialState = [];

export const fetchAsyncAddLegacy = createAsyncThunk(
  "/fetchAsyncAddLegacy",
  async (data) => {
    try {
      const response = await axiosInstance.post('/legacy/create', data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncGetLegacy = createAsyncThunk(
  "/fetchAsyncGetLegacy",
  async () => {
    try {
      let url = `${API_URL}/legacy/get`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

  const AllLegacySlice = createSlice({
    name: "legacyData",
    initialState,
    reducers: {},
    extraReducers: {
      [fetchAsyncGetLegacy.pending]: (state) => {},
      [fetchAsyncGetLegacy.fulfilled]: (state, { payload }) => {
        return payload;
      },
      
    },
  });
  

  export const getAllLegacy = (state) => state.legacyData;
  
  export default AllLegacySlice.reducer;




